import { motion } from "framer-motion";
import { Sparkle } from "lucide-react";

export const MicroMessage = ({ message }) => (
  <motion.div
    data-testid="micro-message"
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0 }}
    className="flex items-start gap-3 px-6 py-5 rounded-2xl bg-[#E2EAE4] border border-[#4A6B56]/20"
  >
    <Sparkle className="w-5 h-5 text-[#4A6B56] mt-0.5 shrink-0" />
    <p className="text-[#3A4A3E] text-base leading-relaxed">{message}</p>
  </motion.div>
);
